// extracted by mini-css-extract-plugin
export default {"mainWrapper":"Invite_mainWrapper__Vv2Jg","formLogin":"Invite_formLogin__2FD65"};